import {isFeatureEnabled} from 'feature-flags';
import {Separator} from 'platform/components';
import {Box, Heading, Space, VStack} from 'platform/foundation';

import {featureFlags} from '@dms/feature-flags';
import {i18n} from '@dms/i18n';

export function LabelColumn() {
  return (
    <Box
      width={40}
      paddingLeft={4}
      flexShrink={0}
      backgroundColor="palettes.neutral.10.100"
      position="sticky"
      left={0}
      borderRight="1px solid"
      borderColor="general.separator"
      zIndex="HEADER"
    >
      <Space vertical={6} />
      <Box position="sticky" top={0} backgroundColor="palettes.neutral.10.100">
        <Space vertical={52} />
        <Heading size={6}>{i18n.t('entity.vehicle.labels.essentials')}</Heading>
        <Space vertical={1} />
        <Separator spacing={0} />
      </Box>
      <Space vertical={1} />
      <VStack spacing={2}>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.position')}
        </Heading>
        <Box height={isFeatureEnabled(featureFlags.SOURCING_PRICE_CHANGES) ? 9 : undefined}>
          <Heading size={6} alternative isSingleLine>
            {i18n.t('entity.vehicle.labels.adPrice')}
          </Heading>
        </Box>
        <Heading size={6} alternative isSingleLine>
          {i18n.t('entity.vehicle.labels.rankEquipment')}
        </Heading>
        <Heading size={6}>{i18n.t('general.labels.documents')}</Heading>
      </VStack>
      <Separator spacing={1} />
      <VStack spacing={2}>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.registration')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.STK')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.serviceBook')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.mileage')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.manufactureYear')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.countryOfOrigin')}
        </Heading>
        <Heading size={6}>{i18n.t('entity.vehicle.labels.performance')}</Heading>
      </VStack>
      <Separator spacing={1} />
      <VStack spacing={2}>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.fuelType')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.power')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.engineCapacity')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.transmission')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.driveType')}
        </Heading>
        <Heading size={6} isSingleLine>
          {i18n.t('entity.vehicle.labels.purchaseInfo')}
        </Heading>
      </VStack>
      <Separator spacing={1} />
      <VStack spacing={2}>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.originalPrice')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.recommendedPrice')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.margin')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.costsPrice')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.LID')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.DOD')}
        </Heading>
        <Heading size={6}>{i18n.t('entity.vehicle.labels.carLook')}</Heading>
      </VStack>
      <Separator spacing={1} />
      <VStack spacing={2}>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.bodyColor')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.numberOfSeats')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.carStyle')}
        </Heading>
        <Heading size={6} alternative>
          {i18n.t('entity.vehicle.labels.numberOfDoors')}
        </Heading>
        <Heading size={6}>{i18n.t('entity.vehicle.labels.features')}</Heading>
      </VStack>
      <Separator spacing={1} />
      <Heading size={6} alternative>
        {i18n.t('entity.vehicle.labels.highlighted')}
      </Heading>
      <Space vertical={44} />
      <Heading size={6} alternative>
        {i18n.t('general.labels.allFeatures')}
      </Heading>
    </Box>
  );
}
